module.exports = __webpack_public_path__ + "img/ico-edit-data.5571fff3.svg";